import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ReactComponent as FlexLeft } from './flex.svg';
import { ReactComponent as FlexRightTop } from './flexbot.svg';
import { ReactComponent as FlexRightBottom } from './flextop.svg';
import { ReactComponent as Card} from './pricing1.svg';
import { ReactComponent as Mobile} from'./mobile2.svg';
import { ReactComponent as Location} from'./location2.svg';
import {ReactComponent as Offer} from './mobile_pricing.svg'

function App() {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const openLink = () => {
    const message = "Hi! we are interested in your classes, could you share more details?";
    const phoneNumber = "+916381983767"; // Replace with the phone number you want to contact
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      // Mobile: open in current window
      window.location.href = url;
    } else {
      // Desktop: open in a new tab
      window.open(url, '_blank');
    }
  };

  const openLink1 = () => {
    // Open a new link (replace with your desired URL)
    let url = "https://maps.app.goo.gl/JSGn1x8ez3V5o2T76"; // or use a relative path like "/home"
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      // Mobile: open in current window
      window.location.href = url;
    } else {
      // Desktop: open in a new tab
      window.open(url, '_blank');
    }
  };

  useEffect(() => {
    const container = containerRef.current;

    const handleScroll = (e) => {
      e.preventDefault();

      // Get the current scroll position
      const scrollLeft = container.scrollLeft;
      const pageWidth = container.clientWidth;
      const currentPage = Math.round(scrollLeft / pageWidth);

      // Determine the next page based on scroll direction
      const delta = Math.sign(e.deltaY);
      const nextPage = delta > 0 ? currentPage + 1 : currentPage - 1;

      // Ensure the next page is within bounds
      if (nextPage >= 0 && nextPage < container.children.length) {
        container.scrollTo({
          left: nextPage * pageWidth,
          behavior: 'smooth',
        });
      }
    };

    container.addEventListener('wheel', handleScroll, { passive: false });

    return () => {
      container.removeEventListener('wheel', handleScroll);
    };
  }, []);

  // Set a timer to hide the spinner after 2 seconds
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000); // 2 seconds
  }, []);
  return (
    <div className="app">
      {loading && (
    <div id="spinner" class="spinner-container">
  <div class="spinner"></div>
  <div class="inner-circle">la.</div>
</div>

      )}
      
      <div className="pages-container" ref={containerRef}>
        <div className="page page-1 center_align" id='home'>
          <div className="container">
            <div className='w-100 d-flex justify-content-center align-items-center h-100 flex-column mb-5'>
              <div className="mb-4 ">
                <div className="heroText">
                  <p className='heroText_upper'>Learn from expert</p>
                  <p className='heroText_lower'>Software engineers</p>
                </div>
              </div>
              <div className="row icon_container">
                <div className="col">
                  <div > <FlexLeft className="one_icon"/></div>
                </div>
                <div className="col d-flex flex-column gap-4 ">
                  <div> <FlexRightTop className="two_icons"/> </div>
                  <div> <FlexRightBottom className="two_icons"/> </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page page-2">
          {/* ------------- page2 faq_page ----------------*/}
          <div className='w-100 d-flex justify-content-center align-items-center h-100 flex-column mb-5'>
            <div className='faq_page'>
              <div className='about_us'>
                <h1 className='about_us_upper'>We're Sibbe & Akash,</h1>
                <p className='about_us_lower'>Helping your child create their first website</p>
              </div>
              <div className='faq_container'>
                <h2 className='faq_title'>Frequently asked questions</h2>
                <div className="faq_list">
                  <div >
                    <h3 className='faq_questions'>1. Why should kids learn computer science?</h3>
                    <p className='faq_answers'>It builds problem-solving, creativity, and prepares them for the future.</p>
                  </div>
                  <div >
                    <h3 className='faq_questions'>2. What will you teach?</h3>
                    <p className='faq_answers'>Basics of coding, logic, and fun real-world projects.</p>
                  </div>
                  <div >
                    <h3 className='faq_questions'>3. Are there classes for college graduates and adults?</h3>
                    <p className='faq_answers'>Yes, we have classes for all ages, we specialize in full stack development.</p>
                  </div>
                  <div >
                    <h3 className='faq_questions'>4. How will this help in school?</h3>
                    <p className='faq_answers'>It improves thinking skills and boosts performance.</p>
                  </div>
                  <div >
                    <h3 className='faq_questions'>5. Is CS useful for their future?</h3>
                    <p className='faq_answers'>Yes, it opens doors to tech careers and life skills.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page page-3">
          <div className="pricing_container">
            <div className="pricing">
              <h1 className="pricing_name">Pricing</h1>
            </div>
            <div >
              <div>
                <Card className="pricing_card"  ></Card>
                <Offer className="pricing_card_mobile"  ></Offer>
              </div>
            </div>
          </div>
        </div>
        <div className="page page-4">
          <div className='ctct_con'>
            <h1 className='contact_us'>Contact us</h1>
            <button className='cubtn' onClick={openLink1}>
                <Location className='cubtn'/>
            </button>
            <button className='cubtn1'  onClick={openLink}>
              <Mobile className='cubtn1' />
            </button>
          </div>
        </div>
      </div>

      <footer className="company-name mb-3">
        <span className="fw-bolder mb-0 pb-0 ">Learning Academy</span>
        <div style={{fontSize:'10px',letterSpacing: '0.05em', color:'#7A7A7A'}}>Namakkal</div>
      </footer>
    </div>
  );
}

export default App;
